<template>
  <div class="wx-dialog-com">
    <el-dialog custom-class="dialog-content" :visible.sync="localShow" :close-on-click-modal="false"
      :close-on-press-escape="false" @close="handleClose" top="0">
      <div class="title">{{ data.title }}</div>
      <div class="detail">
        <span class="describe" v-html="data.describe"></span>
        <img :src='data.imgUrl' class="wx-vip-center-code" alt="barcode-img" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'WXUserCenter',
  props: {
    show: Boolean,
    data: Object
  },
  data() {
    return {
      localShow: this.show
    };
  },
  watch: {
    show(val) {
      this.localShow = val;
    }
  },
  methods: {
    handleClose() {
      this.localShow = false;
      this.$emit('updateShow', false);
    }
  }
};
</script>


<style lang="scss" scoped>
.wx-dialog-com {

  ::v-deep .dialog-content {
    top: 50%;
    transform: translateY(-50%);

    .el-dialog__body {
      padding: 0;
      position: relative;
    }

    .el-dialog__header {
      padding: 0;

      .el-dialog__headerbtn {
        top: 25px;
        right: 25px;
        z-index: 999;

        .el-icon-close {
          font-size: 24px;
          color: #000 !important;
        }
      }
    }

    .title {
      font-size: 18px;
      color: #212322;
      line-height: 20px;
      padding-bottom: 10px;
      position: absolute;
      left: 0;
      right: 0;
      background: #fff;
    }

    .detail {
      display: flex;
      flex-direction: column;
      overflow-y: scroll;
      padding: 44px 40px;

      .describe {
        margin-top: 30px;
        color: #666;
      }


      .wx-vip-center-code {
        margin: 20px auto;
        width: 184px;
        height: 184px;
      }
    }
  }

  @media only screen and (max-width: 780px) {

    ::v-deep .dialog-content {
      width: calc(100% - 48px);

      .title {
        padding-top: 32px;
        font-size: 16px;
      }

      .detail {
        max-height: 612px;
        padding: 44px 20px;

        .wx-vip-center-code {
          margin: 20px auto;
          width: 144px;
          height: 144px;
        }
      }
    }

  }

  @media only screen and (min-width: 780px) {

    ::v-deep .dialog-content {
      width: 680px;

      .title {
        padding-top: 44px;
      }

      .detail {
        max-height: calc(100vh - 300px);
      }
    }
  }

  .el-dialog {
    .detail {
      &::-webkit-scrollbar {
        width: 2px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #888;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #555;
      }
    }
  }
}
</style>
